// extracted by mini-css-extract-plugin
module.exports = {"internalContainer":"styles_internalContainer__3F_WC","adminContainer":"styles_adminContainer__3TFVv","formContainer":"styles_formContainer__UDBpT"};